<template>
    <div class="row no-margins">
        <div class="col-md-2">
            <visual-reporting-filter :amount.sync="filterData.amount"
                                     :from.sync="filterData.from"
                                     :loading="loading"
                                     :search.sync="filterData.search"
                                     :to.sync="filterData.to"
                                     @applyFilter="onApplyFilter" />
        </div>
        <div class="col-md-10">
            <visual-reporting-chart :chart-data="chartData"
                                    :loading="loading" />
        </div>
    </div>
</template>

<script>
    import visualReportingFilter from './visual-reporting-filter.vue';
    import visualReportingChart from './visual-reporting-chart.vue';
    import toaster from "../common/toaster";

    export default {
        components: {
            visualReportingFilter,
            visualReportingChart
        },
        data() {
            return {
                loading: true,
                filterData: {
                    filterGroups: [],
                    all: -1,
                    from: '',
                    to: '',
                    amount: 'top50',
                    search: ''
                },
                chartData: {
                    columns: [],
                    columnnames: [],
                    comments: [],
                    data: []
                },
                localStorageKey: `visual-reporting-filter.${Laravel.activeUser}.${Laravel.activeProject}`
            }
        },
        methods: {
            loadData: function () {
                this.loading = true
                axios.post('/system/reporting/get', {
                    filterData: this.filterData,
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.chartData = _.extend({}, this.chartData, response.data.data.charts);
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(Lang.langGet("Failed to filter data. Please check your input."));
                }).finally(() => this.loading = false);
            },
            onApplyFilter() {
                this.loadData()
                localStorage.setItem(this.localStorageKey, JSON.stringify(this.filterData))
            }
        },
        created() {
            let filterDataString = localStorage.getItem(this.localStorageKey);

            if(filterDataString)
                this.filterData = JSON.parse(filterDataString)
        },
        mounted() {
            this.loadData();
        }
    }
</script>
